import { StateCreator } from "zustand"
import { StoreType } from "./AppStore"

export enum TabStatusEnum {
    CRUD = "CRUD",
    VIEW = "VIEW",
}

export type TabStatusStoreType = {
    tabStatus: TabStatusEnum
    setTabStatus: (status: TabStatusEnum) => void
}

const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
)

const createTabStatusStore: StateCreator<StoreType, [], [], TabStatusStoreType> = (set, get) => {
    return {
        tabStatus: mobile ? TabStatusEnum.VIEW : TabStatusEnum.CRUD,
        setTabStatus: (status: TabStatusEnum) => set({ tabStatus: status }),
    }
}

export default createTabStatusStore
